<template>
  <!-- 用户管理 -->
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
          <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <div>
          <span>姓名</span><el-input v-model="searchForm.username" clearable placeholder="请输入姓名"></el-input>
          <span>账号</span><el-input v-model="searchForm.loginName" clearable placeholder="请输入账号"></el-input>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
          <el-button v-if="roleIds.includes('1')" class="mybtny" v-waves icon="el-icon-edit" @click="addProject">新增仪器管理员</el-button>
        </div>
      </div>
      <div class="table_cm">
        <Table
          ref="multipleTable"
          v-loading="loading"
          :tableData="List"
          :pageSize='pageSize'
          :currentPage="pageIndex"
          :cloumns="cloumns"
          :totalNum="total"
          :pageFlag='true'
          :selection='false'
          @handleCurrentChange="handleCurrentChange"
        >
          <el-table-column
            prop="avatar"
            label="头像"
            align="center"
            width="85"
          >
            <template slot-scope="scope">
              <el-avatar v-if="scope.row.avatar" shape="square" :src="scope.row.avatar"></el-avatar>
              <el-avatar v-else shape="square" src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            :sort-by="['states', 'role']"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="账号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="单位"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="roleName"
            label="角色"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            label="角色"
            align="center"
            :sortable="true"
            sort-by='roleId'
          >
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.roleList" :key="index">
                <span v-if="index != scope.row.roleList.length - 1">{{ item.roleName }} 、</span>
                <span v-else>{{ item.roleName }}</span>
              </span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="创建时间"
            align="center"
            width="165"
          >
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <el-table-column
            label="电子签名"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 50px"
                :src="`https://ims1312586635.cos.apguanghou.myqcloud.com${scope.row.signature}`"
              >
                <div slot="error" class="image-slot">
                  <el-avatar src="https://empty" shape="square">
                    <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                  </el-avatar>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="delFlag"
            label="启用状态"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <div :class="['icon_bg', 'iconfont', scope.row.delFlag == '1' ? 'icon-x' : 'icon-dagou-icon']"></div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="250"
          >
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="editClick(scope.row)">编辑</el-button>
              <el-button type="text" @click.native.prevent="stop(scope.row)">停用</el-button>
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
    <!-- 新增仪器管理员 -->
    <div>
      <el-dialog title="新增仪器管理员" center :visible.sync="addVisible" width="800px"
       v-if="addVisible" :close-on-click-modal="false">
        <add-model @cancel="cancel" @submit="submit"></add-model>
      </el-dialog>
    </div>
    <!-- 编辑用户信息 -->
    <div>
      <el-dialog title="编辑用户信息" center :visible.sync="editVisible" width="500px"
       v-if="editVisible" :close-on-click-modal="false">
        <edit-model @cancel="cancelEdit" @submit="submit" :editData='editData'></edit-model>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getUserInfo, delUser, createUser, updateUser, updatePasw } from "@/api/userApi.js";
import addModel from "./components/addModel";
import editModel from "./components/editModel";
import Table from "@/components/myTable";
export default {
  inject:['reload'],
  components: {
    addModel,
    editModel,
    Table,
  },
  data() {
    return {
      userInfo: '',
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: '', //待编辑项目数据
    }
  },
  computed: {
    roleIds() {
      return this.$store.state.user.roles
    }
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        deptId: this.userInfo.deptId,
        lockFlag: 1,
        current: this.pageIndex,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      getUserInfo(params).then(res => {
        if (res.code == "200") {
          this.List = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg || err.message || "服务器连接失败");
      });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    reset() {
      this.searchForm.userName = '';
      this.searchForm.loginName = '';
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增项目
    addProject() {
      this.addVisible = true;
    },
    // 编辑项目
    editClick(row) {
      let { name, username, password, phone, userId } = row
      this.editData = {
        name,
        username,
        password,
        phone,
        userId
      }
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(data, isAdd) {
      if (isAdd) {
        let params = {
          ...data,
          deptId : data.deptId[data.deptId.length-1]
        }
        createUser(params).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg || '新增成功！');
            this.cancel();
            this.getList();
          } else {
            this.$message.error(res.msg || '新增失败！');
          }
        });
      } else {
        updateUser({ ...data }).then(res => {
          if (res.code == '200') {
            this.$message.success(res.msg || '修改成功！');
            this.cancelEdit();
            this.getList();
          } else {
            this.$message.error(`修改失败`);
          }
        });
      }
    },
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    // 停用
    stop(row) {
      this.$confirm(`确定停用 <strong style="color: #fffe4f">${row.name}</strong> 用户吗?`, '停用提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
      }).then(() => {
        delUser(row.userId).then(res => {
          if (res.code == "200") {
            this.$message.success(res.msg)
            this.getList()
          } else {
            this.$message.error(res.msg)
            this.getList()
          }
        })
      }).catch(() => {});
    },
  },
}
</script>

<style lang="less" scoped>
.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;
  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;
    .bh_cm {
      height: 20px;
      line-height: 20px;
    }
    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 200px;
        margin: 0 20px;
      }
      .el-button {
        width: 140px;
        margin-left: 20px;
      }
      .el-select {
        margin: 0 20px;
      }
    }
    .table_cm {
      height: 100%;
      .el-avatar {
        vertical-align:middle;
      }
      /deep/.image-slot {
        line-height: 57px;
        /deep/.el-icon-picture-outline:before {
          width: 57px;
          height: 57px;
        }
      }
      /deep/.el-table td {
        padding: 0;
      }
      .el-button--text {
        width: 40px;
      }
      .marke {
        .cell /deep/.el-button {
          margin: 0 5px
        }
      }
    }
  }
}

.addModel {
  .addfrom {
    margin: 0 30px;
  }
  /deep/.el-button {
    width: 100px;
  }
  /deep/.el-input__inner {
    width: 260px;
  }
}


.el-table--scrollable-y::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.el-table--scrollable-y::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #86cbfd;
}
.el-table--scrollable-y::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #1f94f1;
}
</style>



// WEBPACK FOOTER //
// src/views/usermanage/index.vue